import { gql } from "graphql-request";

export const CULTURES_QUERY = gql`
  query culturesQuery {
    cultures {
      name
      description
    }
  }
`;
